import { createFileRoute } from "@tanstack/react-router";
import { RevisionSpokePage } from "@/components/site/RevisionSpokePage";
import { revisionSpokeHead } from "@/lib/revision-spoke-head";
import { REVISION_SPOKES } from "@/lib/revision-spokes";
import { REVISION_SPOKE_META } from "@/lib/revision-spoke-meta";

export const Route = createFileRoute("/services/revisions/lap-band")({
  head: () => revisionSpokeHead(REVISION_SPOKE_META["lap-band"], import.meta.env.SSR ? REVISION_SPOKES["lap-band"] : null),
  component: LapBandRevisionPage,
});

function LapBandRevisionPage() {
  return <RevisionSpokePage spoke={REVISION_SPOKES["lap-band"]} />;
}
